import React from 'react'
import classNames from 'classnames'

function Description({ text, modifierClasses = [], children }) {
  const descriptionClasses = classNames(
    'description',
    'description--large',
    'u-text-color-secondary',
    modifierClasses
  )
  return (
    <div
      className={descriptionClasses}
    >
      {text || children}
    </div>
  )
}

export default Description
